import { FC, useEffect, useState } from "react";
import { Dialog, DialogAction } from "src/framework/components/commons/dialogs/Dialog";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import { InputSelectSimple } from "src/framework/components/forms/inputs/InputSelectSimple";
import { EmailInterface } from "src/framework/store/EmailStore";
import { notifierStore } from "src/framework/store/NotifierStore";

export interface EmailDialogProperties {
    modelos: EmailInterface[];
    isOpen: boolean;
    textReadOnly?: boolean;
    onClose: Function;
    sendMail: (email: CorpoEmail) => void;
    
}

interface FormEmail {
    modelos: EmailInterface[];
    onChangeValue: (modelo: number) => void;
    textReadOnly?: boolean;
    isDisabled: boolean;
}

export interface CorpoEmail {
    modelo: number;
    destinatarios: string;
    destinatariosOcultos: string;
    texto: string;
}

const FormEmail: FC<FormEmail> = ({
    modelos,
    onChangeValue,
    isDisabled = true,
    textReadOnly = false,
}) => {

    const [modelo, setModelo] = useState<any>(undefined);

    const handleChangeModelo = (value: number): void => {


        const idxModelo = modelos.findIndex((m) => {
            return parseInt(m.id) === parseInt(String(value))
        })

        if (idxModelo > -1) {

            const elDestinatarios: any = document.getElementById("pedidos-envio-email-destinatarios")
            const elDestinatariosOculto: any = document.getElementById("pedidos-envio-email-destinatarios-ocultos")
            const elTexto: any = document.getElementById("pedidos-envio-email-texto");

            elDestinatarios.value = modelos[idxModelo].destinatarios;
            elDestinatariosOculto.value = modelos[idxModelo].destinatarios_ocultos;
            elTexto.value = modelos[idxModelo].texto;

        }

        onChangeValue(value)
    }

    // useEffect(() => {
    //     const primeiroModelo = [...modelos].shift();
    //     if (primeiroModelo) {
    //         setModelo(primeiroModelo.id)
    //     }
    // }, [modelos]);

    return <>
        <div className="container">
            <div className="row">
                <div className="X12">
                    <InputSelectSimple
                        list={modelos.map((modelo) => {
                            return {
                                text: modelo.nome,
                                value: modelo.id,
                            }
                        }) || []}
                        label={"Modelo"}
                        defaultValue={modelo}
                        value={modelo}
                        onChange={(value) => {
                            setModelo(value)
                            handleChangeModelo(value)
                        }}
                    />
                </div>
                <div className="X12">
                    <InputText
                        disabled={isDisabled  || textReadOnly}
                        id="pedidos-envio-email-destinatarios"
                        InputLabelProps={{ shrink: true }}
                        label={"Destinatários"}
                        fullWidth={true}
                        // value={""}
                        name={"destinatarios"}
                        onChange={(e: any) => {
                        }}
                    />
                </div>
                <div className="X12">
                    <InputText
                        disabled={isDisabled || textReadOnly}
                        id="pedidos-envio-email-destinatarios-ocultos"
                        InputLabelProps={{ shrink: true }}
                        label={"Destinatários Ocultos"}
                        fullWidth={true}
                        // value={destinatariosOcultos}
                        name={"destinatarios_ocultos"}
                        onChange={(e: any) => {
                        }}
                    />
                </div>
                <div className="X12">
                    <InputText
                        disabled={isDisabled || textReadOnly}
                        id="pedidos-envio-email-texto"
                        InputLabelProps={{ shrink: true }}
                        size="medium"
                        label={"Texto"}
                        name={"texto"}
                        multiline
                        fullWidth={true}
                        maxRows={8}
                        onChange={(e: any) => {
                        }}
                    />
                </div>
            </div>
        </div>
    </>
}


const EmailDialog: FC<EmailDialogProperties> = ({
    modelos,
    isOpen,
    textReadOnly = false,
    onClose,
    sendMail,
    children
}) => {
    // States
    const [open, setOpen] = useState<boolean>(false);
    const [isDisabled, setIsDisabled] = useState<boolean>(true);
    const [modeloList, setModeloList] = useState<EmailInterface[]>([])
    const [selectedModelo, setSelectedModelo] = useState<number>(0)


    // Effects
    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen])

    useEffect(() => {
        setModeloList(modelos);
    }, [modelos])

    // Metodos
    const handleEnviar = (): CorpoEmail | void => {

        const elDestinatarios: any = document.getElementById("pedidos-envio-email-destinatarios")
        const elDestinatariosOculto: any = document.getElementById("pedidos-envio-email-destinatarios-ocultos")
        const elTexto: any = document.getElementById("pedidos-envio-email-texto");

        // Validar antes de enviar
        if (selectedModelo === 0) {
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: "O modelo não foi selecionado.",
                timeOut: 2500,
                onClose: () => {
                    notifierStore.setOpen(false);
                }
            });
            notifierStore.setOpen(true);

            return;
        }

        if (elDestinatarios.value === "") {
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: "O campo destinatário é obrigatório.",
                timeOut: 2500,
                onClose: () => {
                    notifierStore.setOpen(false);
                }
            });
            notifierStore.setOpen(true);
            return;
        }


        return {
            modelo: selectedModelo,
            destinatarios: elDestinatarios.value,
            destinatariosOcultos: elDestinatariosOculto.value,
            texto: elTexto.value,
        }
    }

    const actions: DialogAction[] = [
        {
            color: "secondary",
            label: "Fechar",
            onClick: () => {
                setOpen(false);
                if (onClose) {
                    onClose();
                }
            }
        },
        {
            color: "primary",
            label: "Enviar",
            contained: true,
            onClick: () => {
                const corpoEmail: CorpoEmail | null = handleEnviar() || null
                if (corpoEmail !== null) {
                    sendMail(corpoEmail);
                    if (onClose) {
                        onClose();
                    }
                }

            }
        }
    ]

    return <>
        <Dialog
            isOpen={open}
            title="Envio de e-mails"

            onClose={() => {
                onClose();
            }}
            actions={actions}
        >
            <FormEmail
                textReadOnly={textReadOnly}
                modelos={modeloList}
                onChangeValue={(modelo) => {
                    setIsDisabled(parseInt(modelo.toString()) <= 0)
                    setSelectedModelo(modelo)
                }}
                isDisabled={isDisabled}
            />
        </Dialog>

    </>
}

export { EmailDialog }